"use client";

import React from 'react';

interface EmptyLibraryStateProps {
  title: string;
  description: string;
}

export function EmptyLibraryState({ title, description }: EmptyLibraryStateProps) {
  return (
    <div className="text-center py-16 px-4">
      <div className="max-w-md mx-auto">
        {/* Empty library icon */}
        <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-8">
          <svg 
            className="w-12 h-12 text-gray-400" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5} 
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" 
            />
          </svg>
        </div>

        {/* Title */}
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          {title}
        </h3>

        {/* Description */}
        <p className="text-gray-600 mb-8 leading-relaxed">
          {description}
        </p>

        {/* Action buttons */}
        <div className="space-y-4">
          <button 
            onClick={() => window.location.reload()}
            className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors duration-200"
          >
            Thử lại
          </button>
          
          <div className="text-center">
            <a 
              href="/contact" 
              className="text-blue-600 hover:text-blue-700 font-medium transition-colors duration-200"
            >
              Liên hệ hỗ trợ →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}